<template>
    <div class="modal show">
        <div
            class="modal-backdrop show"
            :style="{ zIndex: 'unset' }"
            @click.self="$emit('close')"
        ></div>
        <section :style="{ zIndex: 1 }">
            <div class="modal-dialog popup selectTaskModal">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="modal-title">{{ trans('Select task status') }}</div>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="$emit('close')"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <template v-if="loading">
                            <div class="text-center mb-2">
                                <i class="icofont-spinner"></i>
                            </div>
                        </template>
                        <template v-else>
                            <div class="row">
                                <div class="col-12 my-3">
                                    <ul class="list-group">
                                        <li
                                            class="list-group-item cur-pointer align-items-center d-flex"
                                            v-for="taskStatus in this.taskStatuses"
                                            @click="updateTaskStatus(taskStatus.id)"
                                        >
                                            <div class="d-flex align-items-center">
                                                <span
                                                    class="badge-round round-sm"
                                                    :style="{ backgroundColor: taskStatus.color }"
                                                ></span>
                                                <span>{{ taskStatus.title }}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </template>
                    </div>
                    <!--/ modal-body -->
                </div>
                <!--/ modal-content -->
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'SelecStatusComponent',
    data() {
        return {
            taskStatuses: [],
            loading: false,
        };
    },
    props: {
        taskId: {
            required: true,
            type: Number,
        },
    },
    methods: {
        getAllTaskStatusses() {
            this.loading = true;
            const url = route('schedule.planning.task.getAllStatuses');

            axios
                .get(url)
                .then((response) => {
                    this.taskStatuses = response.data;
                    this.loading = false;
                })
                .catch((response) => {
                    this.loading = false;
                });
        },
        updateTaskStatus(taskStatusId) {
            this.loading = true;

            const url = route('schedule.planning.task.setTaskStatus', {
                taskId: this.taskId,
                statusId: taskStatusId,
            });

            axios
                .post(url)
                .then((response) => {
                    this.loading = false;
                    this.$emit('statusUpdated');
                })
                .catch((response) => {
                    this.loading = false;
                });
        },
    },
    created() {
        this.getAllTaskStatusses();
    },
};
</script>
